import React from "react";
import styled from "styled-components";

// Styled Components
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6); /* Semi-transparent black background */
  z-index: 1000;
`;

const ModalContainer = styled.div`
  width: 350px;
  padding: 24px;
  background-color: #033b40; /* Dark teal */
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.2);
  position: relative;
`;

const Title = styled.h2`
  font-family: Verdana, sans-serif;
  font-size: 18px;
  font-weight: bold;
  color: #d9ffff; /* Light teal */
  text-align: center;
  margin-bottom: 16px;
`;

const Message = styled.div`
  font-family: Verdana, sans-serif;
  font-size: 14px;
  color: #acbfbf; /* Muted teal text */
  text-align: center;
  margin-bottom: 24px;

  .highlight {
    font-style: italic;
    color: #0af; /* Bright teal for emphasis */
  }
`;

const BoxImage = styled.img`
  width: 80px;
  height: 80px;
  margin-bottom: 16px;
`;

const CloseButton = styled.button`
  padding: 8px 16px;
  background-color: #10b981; /* Emerald green */
  color: white;
  border-radius: 8px;
  font-size: 14px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #059669; /* Darker emerald */
  }
`;

const SuccessModal: React.FC<{
  isVisible: boolean;
  onClose: () => void;
  message: string; // Pass raw HTML string
  boxImageUrl: string;
}> = ({ isVisible, onClose, message, boxImageUrl }) => {
  if (!isVisible) return null;

  return (
    <Overlay>
      <ModalContainer>
        <Title>Gift Box Sent</Title>
        <Message dangerouslySetInnerHTML={{ __html: message }} />
        <BoxImage src={boxImageUrl} alt="Gift Box" />
        <CloseButton onClick={onClose}>Close</CloseButton>
      </ModalContainer>
    </Overlay>
  );
};

export default SuccessModal;
